<template>
    <v-container fluid>
        <v-snackbar
            v-model="showToast"
            color="red lighten-1"
            text
            top
            right
            rounded
            class="mt-3"
        >
            {{ toastMsg }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red lighten-1"
                    text
                    v-bind="attrs"
                    @click="showToast = false"
                >
                    <v-icon color="red lighten-1">
                        close
                    </v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-row class="px-6">
            <v-col
                class="mt-4 pb-4 px-0 add-rule-header"
                cols="12"
            >
                <div class="header-content">
                    <div>
                        <v-btn
                            icon
                            style="background: #F5F7FA;"
                            to="/settings/supplemental-messages"
                        >
                            <v-icon class="material-icons-outlined">
                                chevron_left
                            </v-icon>
                        </v-btn>
                        <span class="ml-3">{{ editMode ? 'Edit' : 'Add' }} Supplemental Message Rule</span>
                    </div>
                </div>
            </v-col>
            <v-col
                class="mt-4 pb-4 pl-0"
                cols="12"
            >
                <div>
                    <v-form
                        ref="form"
                        v-model="valid"
                    >
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="name"
                                    dense
                                    outlined
                                    label="Name/Description *"
                                    hide-details="auto"
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="enabled"
                                    dense
                                    hide-details
                                    label="Enabled"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="no_autorespond"
                                    dense
                                    label="Do not send Tickets with an Auto-response applied"
                                    hide-details=""
                                />
                            </v-col>
                            <v-col cols="12">
                                <h3 class="divider">
                                    What to receive
                                </h3>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="messageType_tickets"
                                    dense
                                    hide-details
                                    label="Tickets"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="messageType_audits"
                                    dense
                                    hide-details
                                    label="EOD Audits"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="messageType_messages"
                                    dense
                                    hide-details
                                    label="Messages"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    ref="email"
                                    v-model="email"
                                    dense
                                    outlined
                                    label="Email"
                                    hide-details="auto"
                                    :rules="[rules.email]"
                                    @input="checkCellAndEmailValidation"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-select
                                    v-model="email_format"
                                    dense
                                    :items="emailTicketFormat"
                                    item-text="name"
                                    item-value="value"
                                    outlined
                                    label="Email Ticket Format"
                                    hide-details
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    ref="sms_cell_number"
                                    v-model="sms_cell_number"
                                    maxlength="16"
                                    dense
                                    outlined
                                    label="Cell Phone (SMS)"
                                    :rules="[rules.smsRule]"
                                    hide-details="auto"
                                    @input="checkCellAndEmailValidation"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-select
                                    v-model="sms_format"
                                    dense
                                    :items="smsFormats"
                                    item-text="name"
                                    item-value="value"
                                    outlined
                                    label="SMS Format"
                                    hide-details
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-select
                                    v-model="center_id"
                                    dense
                                    :items="centers"
                                    item-text="name"
                                    item-value="value"
                                    outlined
                                    label="Center"
                                    hide-details
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-select
                                    v-model="member_codes"
                                    dense
                                    :items="centerMemberCodes"
                                    item-text="name"
                                    item-value="value"
                                    outlined
                                    label="Member Codes"
                                    hide-details
                                    multiple
                                    @input="allSelectHandler"
                                />
                            </v-col>
                            <v-col
                                v-if="messageType_tickets === true"
                                cols="9"
                                class="pr-0"
                            >
                                <v-row>
                                    <v-col>
                                        <v-divider class="mb-5" />
                                        <h3>Center, Ticket Priority, Type and Category</h3>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col
                                v-if="messageType_tickets === true"
                                cols="3"
                                class="pl-0"
                            >
                                <v-row class="text-right">
                                    <v-col>
                                        <v-divider class="mb-5" />
                                        <v-btn
                                            outlined
                                            style="text-transform: none;"
                                            @click="addUpdateDialog=true"
                                        >
                                            <v-icon left>
                                                mdi-plus
                                            </v-icon>
                                            Add
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col
                                v-if="messageType_tickets === true"
                                cols="12"
                            >
                                <v-row
                                    v-if="filters.length===0"
                                    align="center"
                                    justify="center"
                                    class="text-center no-priority m-3"
                                >
                                    <v-col>There are no priority, type and category defined yet.</v-col>
                                </v-row>
                                <v-simple-table
                                    v-else
                                    class="image-table"
                                >
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Center
                                                </th>
                                                <th class="text-left">
                                                    Priority
                                                </th>
                                                <th class="text-left">
                                                    Type
                                                </th>
                                                <th class="text-left">
                                                    Category
                                                </th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(item, index) in filters"
                                                :key="index"
                                            >
                                                <td>{{ getFilterFieldLabel('center', item.center) }}</td>
                                                <td>{{ getFilterFieldLabel('priority', item.priority) }}</td>
                                                <td>{{ getFilterFieldLabel('type', item.type) }}</td>
                                                <td>{{ getFilterFieldLabel('category', item.category) }}</td>
                                                <td class="text-center">
                                                    <v-icon
                                                        class="mr-2"
                                                        @click="editFilter(index)"
                                                    >
                                                        mdi-pencil-outline
                                                    </v-icon>
                                                    <v-icon
                                                        class="mr-2"
                                                        @click="removeFilter(index)"
                                                    >
                                                        mdi-delete-outline
                                                    </v-icon>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-divider />
                                <v-select
                                    v-model="send_days"
                                    dense
                                    :items="sendDaysOptions"
                                    :rules="[rules.sendDays]"
                                    item-text="name"
                                    item-value="value"
                                    outlined
                                    label="Send Days"
                                    hide-details
                                    multiple
                                    chips
                                >
                                    <template v-slot:prepend-item>
                                        <v-list-item
                                            ripple
                                            @mousedown.prevent
                                            @click="selectAllSendDays"
                                        >
                                            <v-list-item-action>
                                                <v-icon :color="send_days.length > 0 ? 'indigo darken-4' : ''">
                                                    {{ icon }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    Select All
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider class="mt-2" />
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip small>
                                            {{ item.name }}
                                        </v-chip>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="send_times"
                                    dense
                                    outlined
                                    :rules="[rules.timeslotValidate]"
                                    label="Send Times"
                                    persistent-hint
                                    hint="Leave blank to allow sending at any time of day, or enter one or more comma-separated time ranges. Example: &quot;6am-6pm&quot; or &quot;12am-5:30am,6pm-12am&quot;"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-btn
                                    style="text-transform: none !important"
                                    outlined
                                    @click="$router.push('/settings/supplemental-messages')"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    class="ml-3"
                                    style="text-transform: none !important"
                                    depressed
                                    color="primary"
                                    @click="submit"
                                >
                                    {{ editMode ? 'Update' : 'Add' }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-col>
            <v-dialog
                v-model="addUpdateDialog"
                max-width="500px"
                persistent
                scrollable
                :fullscreen="this.$vuetify.breakpoint.xsOnly"
            >
                <v-card>
                    <v-card-title>
                        Add Center, Ticket Priority, Type and Category
                    </v-card-title>
                    <v-card-text class="mt-5">
                        <v-form>
                            <v-select
                                v-model="filter_center_id"
                                dense
                                :items="filterCenters"
                                item-text="name"
                                item-value="value"
                                outlined
                                label="Center"
                                class="mt-2"
                            />
                            <v-select
                                v-model="filter_ticket_priority"
                                dense
                                :items="companyTicketPriorities"
                                item-text="name"
                                item-value="value"
                                outlined
                                label="Priority"
                                class="my-3"
                            />
                            <v-select
                                v-model="filter_ticket_type"
                                dense
                                :items="companyTicketTypes"
                                item-text="name"
                                item-value="value"
                                outlined
                                label="Type"
                                class="my-3"
                            />
                            <v-select
                                v-model="filter_ticket_category"
                                dense
                                :items="companyTicketCategories"
                                item-text="name"
                                item-value="value"
                                outlined
                                label="Category"
                                class="mt-3"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="justify-end mr-2 mb-3">
                        <v-btn
                            style="text-transform: none !important"
                            class="text-subtitle-2"
                            outlined
                            @click="addUpdateDialog=false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            style="text-transform: none !important"
                            class="text-subtitle-2"
                            depressed
                            color="primary"
                            @click="addUpdateFilter"
                        >
                            {{ updateFilterIndex > -1 ? 'Update' : 'Add' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-overlay :value="loading">
            <div
                v-if="loading"
                class="d-flex justify-center align-center w-100p"
                style="height: 70vh;"
            >
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                />
            </div>
        </v-overlay>
    </v-container>
</template>

<script>
import webtmsBackend from '@/services/webtmsBackend';
import { formatPhone, validatePhoneNumber } from '@/utils/phone.js';

export default {
    data() {
        return {
            valid: true,
            name: '',
            email: '',
            sms_cell_number:'',
            sms_format:'SMSTEXT',
            smsFormats:['SMSTEXT'],
            enabled: true,
            no_autorespond: false,
            email_format: 'ORIGHTML',
            center_id: 0,
            messageType_tickets: true,
            messageType_audits: false,
            messageType_messages: false,
            send_days: ['SUNDAY','MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY'],
            send_times: '',
            filter_ctrpritypcat: '',
            member_codes: ['*'],
            sendDaysOptions: [
                {name: 'Sunday', value: 'SUNDAY'},
                {name: 'Monday', value: 'MONDAY'},
                {name: 'Tuesday', value: 'TUESDAY'},
                {name: 'Wednesday', value: 'WEDNESDAY'},
                {name: 'Thursday', value: 'THURSDAY'},
                {name: 'Friday', value: 'FRIDAY'},
                {name: 'Saturday', value: 'SATURDAY'},
            ],
            rules: {
                required: value => !!value,
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value);
                },
                smsRule: value => validatePhoneNumber(value),
                sendDays: value =>  value.length>0,
                timeslotValidate: value => {
                    let check = this.timeslotValidate(value);
                    return check.success === true ? true : check.err;
                }
            },
            addUpdateDialog: false,
            filters: [],
            filter_center_id: '',
            filter_ticket_priority: '*',
            filter_ticket_type: '*',
            filter_ticket_category: '*',
            showToast: false,
            toastMsg: '',
            updateFilterIndex: -1,
            loading: false,
            editMode: false,
            rowid: ''
        };
    },
    computed: {
        centers() {
            const centers = this.$store.getters.companyCenters.map(item => { return { name: item.center_abbrev, value: item.center_id};});
            return [{name: 'Any', value: 0}, ...centers];
        },
        filterCenters() {
            const centers = this.$store.getters.companyCenters.map(item => { return { name: item.center_abbrev, value: item.center_id};});
            return centers;
        },
        getCompanyOptions() {
            return this.$store.getters.companyOptions;
        },
        emailTicketFormat() {
            let formats = [
                {name: 'Original Text', value: 'ORIGINAL'},
                {name: 'Original HTML', value: 'ORIGHTML'},
                {name: 'Original Transmission', value: 'ORIGXMIT'}
            ];
            if(this.getCompanyOptions) {
                let companyOptions = this.getCompanyOptions
                    .filter(item => item.option.startsWith('TICKET_FORMAT_') && item.option !== 'TICKET_FORMAT_LIST');
                if (companyOptions) {
                    companyOptions = companyOptions.map(e => { return e.option.replace('TICKET_FORMAT_', ''); }).sort();
                }
                let dynamicFormats = companyOptions.map(item => { return { name: item, value: item };});
                formats = [...formats, ...dynamicFormats];
            }
            return formats;
        },
        centerMemberCodes(){
            if(this.center_id === '') {
                return [{
                    name: 'Any',
                    value: '*'
                }];
            }
            let centerMemberCodes = [];
            centerMemberCodes.push({
                name: 'Any',
                value: '*'
            });
            const companyMemberCodes = this.$store.getters.companyMemberCodes;
            for(let memberCode of companyMemberCodes) {
                if (this.center_id === 0) {
                    centerMemberCodes.push({
                        name: memberCode.member_code,
                        value: memberCode.member_code
                    });
                }else if (memberCode.center_id === this.center_id) {
                    centerMemberCodes.push({
                        name: memberCode.member_code,
                        value: memberCode.member_code
                    });
                }
            }
            return centerMemberCodes;
        },
        selectedAllSendDays () {
            return this.send_days.length === this.sendDaysOptions.length;
        },
        selectedSomeSendDays () {
            return this.send_days.length > 0 && !this.selectedAllSendDays;
        },
        icon () {
            if (this.selectedAllSendDays) return 'mdi-close-box';
            if (this.selectedSomeSendDays) return 'mdi-minus-box';
            return 'mdi-checkbox-blank-outline';
        },
        companyTicketPriorities() {
            let companyTicketPriorities  = [];
            companyTicketPriorities.push({name: 'Any',value: '*'});
            for(let priority of this.$store.getters.companyTicketPriorities) {
                companyTicketPriorities.push({name: priority.abbrev, value: priority.abbrev});
            }
            return companyTicketPriorities;
        },
        companyTicketTypes() {
            let companyTicketTypes = [];
            companyTicketTypes.push({name: 'Any',value: '*'});
            for(let ticketType of this.$store.getters.companyTicketTypes) {
                companyTicketTypes.push({name: ticketType.abbrev, value: ticketType.abbrev});
            }
            return companyTicketTypes;
        },
        companyTicketCategories() {
            let companyTicketCategories = [];
            companyTicketCategories.push({name: 'Any',value: '*'});
            for(let category of this.$store.getters.companyTicketCategories) {
                companyTicketCategories.push({name: category.abbrev, value: category.abbrev});
            }
            return companyTicketCategories;
        },
    },
    watch: {
        addUpdateDialog(value){
            if (this.updateFilterIndex > -1) {
                let item = this.filters[this.updateFilterIndex];
                this.filter_center_id = item.center;
                this.filter_ticket_priority = item.priority;
                this.filter_ticket_type = item.type;
                this.filter_ticket_category = item.category;
            } else {
                this.filter_center_id = this.center_id != '0' ? this.center_id : this.filterCenters[0].value;
                this.filter_ticket_priority = '*';
                this.filter_ticket_type = '*';
                this.filter_ticket_category = '*';
            }
            if (value === false) {
                this.updateFilterIndex = -1;
            }
        },
        center_id(value) {
            if(value != 0) {
                this.filters = [];
            }
        },
        sms_cell_number(){
            this.sms_cell_number = this.formatPhone(this.sms_cell_number);
        }
    },
    mounted() {
        if(this.$route.path.includes('/edit')) {
            this.setSelectedRule();
        }
    },
    methods: {
        allSelectHandler(e) {
            if (e.length === 0) {
                e.push('*');
                return;
            }
            if (e.includes('*')) {
                if (e.length === 2) {
                    let tmp = e[1];
                    e.length = 0;
                    e.push(tmp);
                } else {
                    e.length = 0;
                    e.push('*');
                }
            }
        },
        checkCellValidation() {
            if (this.email.length === 0 && this.sms_cell_number.length === 0) return false;
            if (this.sms_cell_number.length === 0 || this.sms_cell_number.replace(/\D/g, '').length === 10) {
                return true;
            } else {
                return 'Invalid Phone number.  Must be 10 digits (area code + phone number).';
            }
        },
        checkEmailValidation() {
            if (this.email.length === 0 && this.sms_cell_number.length === 0) return false;
            const pattern = /^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|(^$))$/;
            return pattern.test(this.email);
        },
        checkCellAndEmailValidation() {
            this.rules.email = this.checkEmailValidation();
            this.rules.smsRule = this.checkCellValidation();
        },
        async submit() {
            this.$refs.form.validate();
            if (!this.valid) {
                return this.alertMessage('Please enter valid values');
            }

            let message_type = '';
            if (this.messageType_tickets === true) message_type += 'T';
            if (this.messageType_audits === true) message_type += 'A';
            if (this.messageType_messages === true) message_type += 'M';
            if (!message_type) return this.alertMessage('You must select 1 or more items in What to Receive.');

            let filter_ctrpritypcat = '';
            if (this.messageType_tickets === true) {
                this.filters.forEach(filter => {
                    filter_ctrpritypcat += `${filter.center},${filter.priority},${filter.type},${filter.category}|`;
                });
                if (filter_ctrpritypcat.length>0) filter_ctrpritypcat = filter_ctrpritypcat.slice(0, -1);
            }
            
            let member_codes = '';
            if (!member_codes.includes('*')) {
                member_codes = this.member_codes.join(',');
            }

            let send_days = '0000000';
            for(let i=0; i<this.sendDaysOptions.length; i++) {
                if (this.send_days.includes(this.sendDaysOptions[i].value)) {
                    send_days = send_days.substring(0, i) + '1' + send_days.substring(i+1);
                }
            }

            const send_times = this.timeslotValidate(this.send_times);
            const payload = {
                'rowid': '',
                'name': this.name,
                'email': this.email,
                'sms_cell_number': this.sms_cell_number,
                'sms_format': this.sms_format,
                'enabled': this.enabled,
                'no_autorespond': this.no_autorespond,
                'center_id': this.center_id.toString(),
                'message_type': message_type,
                'email_format': this.email_format,
                'filter_ctrpritypcat': filter_ctrpritypcat,
                'stype_filter': '',
                'member_codes': member_codes,
                'send_days': send_days,
                'send_times': send_times.normalized,
                'operation': 'insert'
            };
            this.loading = true;
            let response;

            if(this.editMode) {
                payload.operation = 'update';
                payload.rowid = this.rowid;
                response = await webtmsBackend.supplementalMessageRule(payload);
            } else {
                payload.operation = 'insert';
                response = await webtmsBackend.supplementalMessageRule(payload);
            }
            
            if(response && response.result === 'OK') {
                await this.$store.dispatch('updateCompanyEmailSupplemental');
                this.$router.go(-1);
            } else {
                this.alertMessage('Something went wrong');
            }
            this.loading = false;
        },
        selectAllSendDays() {
            this.$nextTick(() => {
                if (this.selectedAllSendDays) {
                    this.send_days = [];
                } else {
                    const options = [...this.sendDaysOptions];
                    this.send_days = options.map(item => item.value);
                }
            });
        },
        addUpdateFilter() {
            if (this.filter_ticket_priority === '*' && this.filter_ticket_type === '*' && this.filter_ticket_category === '*')  {
                this.alertMessage('Please select atleast one filter from Priority, Type and Category.');
                return;
            }
            let filterItem = {
                center: this.filter_center_id,
                priority: this.filter_ticket_priority,
                type: this.filter_ticket_type,
                category: this.filter_ticket_category
            };
            if (this.updateFilterIndex > -1) {
                let filters = [...this.filters];
                filters[this.updateFilterIndex] = filterItem;
                this.filters = filters;
            } else {
                this.filters.push(filterItem);
            }
            this.addUpdateDialog = false;
        },
        editFilter(index) {
            this.updateFilterIndex = index;
            this.addUpdateDialog = true;
        },
        removeFilter(index) {
            this.filters.splice(index, 1);
        },
        getFilterFieldLabel(field, value) {
            let response = '';
            switch (field) {
                case 'center': {
                    let find = this.centers.find(item => item.value === value);
                    response = find.name;
                    break;
                }
                case 'priority': {
                    let find = this.companyTicketPriorities.find(item => item.value === value);
                    response = find.name;
                    break;
                }
                case 'type': {
                    let find = this.companyTicketTypes.find(item => item.value === value);
                    response = find.name;
                    break;
                }
                case 'category': {
                    let find = this.companyTicketCategories.find(item => item.value === value);
                    response = find.name;
                    break;
                }
                default: {
                    break;
                }
            }
            return response;
        },
        alertMessage(message) {
            this.showToast = true;
            this.toastMsg = message;
        },
        setSelectedRule() {
            let selectedRule = this.$store.getters.selectedEmailSupplementalRule;
            if(Object.keys(selectedRule).length === 0) {
                this.$router.push('/settings/supplemental-messages');
                return;
            }
            
            let send_days = [];
            if (selectedRule.send_days[0] == 1) send_days.push('SUNDAY');
            if (selectedRule.send_days[1] == 1) send_days.push('MONDAY');
            if (selectedRule.send_days[2] == 1) send_days.push('TUESDAY');
            if (selectedRule.send_days[3] == 1) send_days.push('WEDNESDAY');
            if (selectedRule.send_days[4] == 1) send_days.push('THURSDAY');
            if (selectedRule.send_days[5] == 1) send_days.push('FRIDAY');
            if (selectedRule.send_days[6] == 1) send_days.push('SATURDAY');
            
            let filters = [];
            if (selectedRule.filter_ctrpritypcat) {
                let filterRules = selectedRule.filter_ctrpritypcat.split('|');
                filterRules.forEach(ruleStr => {
                    let rule = ruleStr.split(',');
                    filters.push({
                        center: parseInt(rule[0]),
                        priority: rule[1],
                        type: rule[2],
                        category: rule[3]
                    });
                });
            }
            
            this.editMode = true;
            this.name = selectedRule.name;
            this.email = selectedRule.email;
            this.sms_cell_number = selectedRule.sms_cell_number;    
            this.enabled = selectedRule.enabled;
            this.no_autorespond = selectedRule.no_autorespond;
            this.email_format = selectedRule.email_format;
            this.center_id = selectedRule.center_id;
            this.messageType_tickets = selectedRule.message_type.includes('T');
            this.messageType_audits = selectedRule.message_type.includes('A');
            this.messageType_messages = selectedRule.message_type.includes('M');
            this.send_days = send_days;
            this.send_times = selectedRule.send_times;
            this.filters = filters;
            this.member_codes = selectedRule.member_codes.split(',');
            this.rowid = selectedRule.rowid;
        },
        timeslotValidate(ts) {
            ts = ts.toLowerCase().replace(/\s+/g, ''); // remove all spaces and make lower case
            var result = { success: true, err: '', normalized: '', inTimeslot: true }; // optimistic
            if (ts.length === 0) return result;
            result.inTimeslot = false; // until proven otherwise
            var now = new Date();
            var normalized = [], from_to, i, parts = ts.split(','); // split comma-separated parts (if any)
            for (i = 0; i < parts.length; i++) {
                from_to = parts[i].split('-');
                if (from_to.length !== 2) {
                    result.success = false;
                    result.err = 'Invalid time range, ' + (from_to.length < 2 ? 'no hyphen' : 'too many hyphens') + ' found.';
                    return result;
                }
                var __verifyTime = function (tm) {
                    // time tm can look like "12am" or "4:00pm" .. normalize for JS to 'HH:MM TT' where HH = hours, MM = minutes, TT = AM|PM
                    var hr, mn;
                    var am = tm.indexOf('am'), pm = tm.indexOf('pm');
                    if ((am <= 0) && (pm <= 0)) {
                        result.success = false;
                        result.err = 'Invalid time specification: ' + tm;
                        return false;
                    }
                    tm = tm.replace('am', '').replace('pm', ''); // remove am/pm
                    if (tm.indexOf(':') === 0) { // starts with :
                        result.success = false; result.err = 'Invalid time specification: ' + tm; return false;
                    }
                    if (tm.indexOf(':') === (tm.length - 1)) { // ends in :
                        result.success = false; result.err = 'Invalid time specification: ' + tm; return false;
                    }
                    if (tm.indexOf(':') > 0) {
                        hr = Number(tm.split(':')[0]);
                        mn = Number(tm.split(':')[1]);
                    } else {
                        hr = Number(tm);
                        mn = 0;
                    }
                    if (isNaN(hr) || (hr < 1) || (hr > 12)) {
                        result.success = false; result.err = 'Invalid time specification: ' + tm; return false;
                    }
                    if (isNaN(mn) || (mn < 0) || (mn > 59)) {
                        result.success = false; result.err = 'Invalid time specification: ' + tm; return false;
                    }
                    return hr + ':' + String(mn).padStart(2, '0') + (pm > 0 ? ' PM' : ' AM');
                };
                var fromTime = __verifyTime(from_to[0]); if (typeof fromTime !== 'string') return result; // failed?
                var toTime = __verifyTime(from_to[1]); if (typeof toTime !== 'string') return result; // failed?

                var from = new Date((now.getMonth() + 1) + '/' + now.getDate() + '/' + now.getFullYear() + ' ' + fromTime);
                var to = new Date((now.getMonth() + 1) + '/' + now.getDate() + '/' + now.getFullYear() + ' ' + toTime);
                if (from === to) {
                    // 12am-12am, etc, means any time of day
                    result.inTimeslot = true;
                } else {
                    if (from < to) {
                        // time does not wrap midnight -- like 9am-5pm
                        if ((now > from) && (now < to)) result.inTimeslot = true;
                    } else {
                        // time wraps around midnight -- like 10pm-5am
                        if ((now < to) || (now > from)) result.inTimeslot = true;
                    }
                }
                normalized.push(fromTime + '-' + toTime);
            }
            result.normalized = normalized.join(',').toLowerCase().replace(/\s+/g, '').replace(/:00/g, '');
            return result;
        },
        formatPhone(phone) {
            if(phone) {
                return formatPhone(phone);
            }
            return phone;
        }
    },
    unmounted() {
        this.$store.commit('SET_SELECTED_EMAIL_SUPPLEMENTAL_RULE', {});
    }
};
</script>

<style scoped>
    .divider {
        border-top: 1px solid #D5D8DE;
        padding-top: 20px;
        color: #35383F;
    }
    .no-priority {
        border: 1px solid #D5D8DE;
        border-radius: 10px;
        height:100px;
        margin: 0;
    }
    .v-select__selections .v-chip {
        margin-top: 6px;
    }
</style>